// extracted by mini-css-extract-plugin
export default {"container":"style_container__SOFXO","card":"style_card__UfqrI"};